/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'attractive' }, { id: 'attention' }, { id: 'confident' }, { id: 'rightCut' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-improve"
      progress={15}
      field="hairstyleWomenImprove"
      setter="setHairstyleWomenImprove"
      ns="hairstyleWomenImprove"
      imageName="hairstyleWomenImprove"
      options={OPTIONS}
    />
  );
}

export default Page;
